import React, { } from 'react';
import { useSelector } from 'react-redux';
import { getOrganizatorFromRoles } from '../../../common/Tool';
import PromokodiBlock from '../../components/PromokodiBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useOrganizerContext } from '../../../common/Context';


export default function OrganizerComissionPromocodes(props) {
    const [org, setOrg] = useOrganizerContext();
    // const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"], true)); // Организатор
    // const auth = useAuth()
    // const [organizator, setOrganizator] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/org/list-by-admin', ({data})=>{
    //         setOrganizator(data);
    //     }, errorCatch)
    // }, [])

    // /api/meropriyatiya/list/com?detail=model
    // /api/meropriyatiya/list/fed?detail=model
    // /api/meropriyatiya/list/reg?detail=model
    // /api/meropriyatiya/list/org?detail=model
    // /api/meropriyatiya/list/school?detail=model

    return (
        <PageLayout>
            <PromokodiBlock {...props} source={"/api/promokodi/list/org?detail=model"}
                sourceKey="org"
                create={true}
                ctx={{organizatorMeropriyatiyaID: org?.ID}}
                // context={{
                //     collection: organizator,
                //     name: (item) => item.nazvanie,
                //     mix: (item) => {
                //         return {
                //             // organizatorFederatsiyaID: 1, // Организатор федерация
                //             // organizatorShkolaID: item.ID, // Организатор школа
                //             organizatorMeropriyatiyaID: item.ID, // Организатор мероприятия
                //             // organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
                //         }
                //     }
                // }}
            />
        </PageLayout>
    );
}
